import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import DocumentService from '@/features/documents/services';
import { processClientResponse, formatClient, formatContact, formatReputation,
 processContactResponse, processReputationResponse, processOperationsByClient } from './utils';


const EXISTED_DNI_URL = `${API_CONFIG.API}/node/client?include=civil_state,contacto,person,reputations&
                      filter[dni-filter][condition][path]=dni&
                      filter[dni-filter][condition][operator]=STARTS_WITH&
                      filter[dni-filter][condition][value]=`;
const EXISTED_CONTACT_DNI_URL = `${API_CONFIG.API}/node/contacto?
                      filter[dni-filter][condition][path]=dni_contacto&
                      filter[dni-filter][condition][operator]=STARTS_WITH&
                      filter[dni-filter][condition][value]=`;
const CLIENT_BY_NAME_URL = `${API_CONFIG.API}/node/client?include=civil_state,contacto,person,reputations&
                      filter[name-filter][condition][path]=nombre&
                      filter[name-filter][condition][operator]=STARTS_WITH&
                      filter[name-filter][condition][value]=`;
const CONTACT_BY_NAME_URL = `${API_CONFIG.API}/node/contacto?
                      filter[name-filter][condition][path]=nombre_contacto&
                      filter[name-filter][condition][operator]=STARTS_WITH&
                      filter[name-filter][condition][value]=`;
const CLIENT_BY_SURNAME = `${API_CONFIG.API}/node/client?include=civil_state,contacto,person,reputations&
                      filter[surname-filter][condition][path]=apellidos&
                      filter[surname-filter][condition][operator]=STARTS_WITH&
                      filter[surname-filter][condition][value]=`;
const CONTACT_BY_SURNAME = `${API_CONFIG.API}/node/contacto?
                      filter[surname-filter][condition][path]=apellidos_contacto&
                      filter[surname-filter][condition][operator]=STARTS_WITH&
                      filter[surname-filter][condition][value]=`;
const CLIENTE_URL = `${API_CONFIG.API}/node/client`;
const CONTACT_URL = `${API_CONFIG.API}/node/contacto`;
const REPUTATION_URL = `${API_CONFIG.API}/node/online_reputation`;
const OPERATIONS_BY_CLIENT = `${API_CONFIG.API}/node/operation?
                      filter[name-filter][condition][path]=clients.uuid&
                      filter[name-filter][condition][operator]==&
                      filter[name-filter][condition][value]=`;
export default {
  getExistedDNI(dni) {
    const promises = [];
    return base.http().get(`${EXISTED_DNI_URL}${dni}`)
      .then(response => processClientResponse(response))
      .then((clientFromServer) => {
        const clientResponse = clientFromServer[0];
        if (clientResponse && clientResponse.reputations &&
        clientResponse.reputations.length > 0) {
          clientResponse.reputations.forEach((e) => {
            promises.push(this.getReputation(e.id));
          });
        }
        return Promise.all(promises).then((res) => {
          if (clientResponse) {
            clientResponse.reputations = res;
            return clientResponse;
          }
          return {};
        });
      });
  },
  getCliente(cliente) {
    const promises = [];
    if (cliente.id && cliente.id !== 'dummy') {
      return base.http().get(`${CLIENTE_URL}/${cliente.id}?include=civil_state,contacto,person,reputations`)
        .then(res => processClientResponse(res))
        .then((clientFromServer) => {
          const clientResponse = clientFromServer;
          if (clientResponse && clientResponse.reputations &&
            clientResponse.reputations.length) {
            clientResponse.reputations.forEach((e) => {
              promises.push(this.getReputation(e.id));
            });
          }
          return Promise.all(promises).then((res) => {
            if (clientResponse) {
              clientResponse.reputations = res;
              return clientResponse;
            }
            return {};
          });
        });
    }
    return this.getExistedDNI(cliente.dni).then((response) => {
      if (response && response.id && response.id.length > 0) {
        return response;
      }
      const error = {
        response: {
          msg: 'Cliente no encontrado',
          status: 404,
        },
      };
      throw error;
    });
  },
  saveCliente(cliente) {
    return base.http().post(`${CLIENTE_URL}?include=civil_state,contacto,person,reputations`, formatClient(cliente))
      .then(response => processClientResponse(response));
  },
  updateCliente(cliente) {
    return base.http().patch(`${CLIENTE_URL}/${cliente.id}?include=civil_state,contacto,person,reputations`, formatClient(cliente))
      .then(response => processClientResponse(response));
  },
  saveClienteContacto(client, contact) {
    return base.http().post(`${CONTACT_URL}`, formatContact(contact))
      .then(contactResponse => processContactResponse(contactResponse))
      .then((contactModel) => {
        client.contact = contactModel;
        return base.http().patch(`${CLIENTE_URL}/${client.id}?include=civil_state,contacto,person,reputations`, formatClient(client));
      })
      .then(clientResponse => processClientResponse(clientResponse));
  },
  saveClienteReputation(client, reputation) {
    return base.http().post(`${REPUTATION_URL}`, formatReputation(reputation))
      .then(reputationResponse => processReputationResponse(reputationResponse))
      .then((reputationModel) => {
        client.reputations.push(reputationModel);
        return base.http().patch(`${CLIENTE_URL}/${client.id}?include=civil_state,contacto,person,reputations`, formatClient(client));
      })
      .then(clientResponse => processClientResponse(clientResponse));
  },
  updateContacto(contact) {
    return base.http().patch(`${CONTACT_URL}/${contact.id}`, formatContact(contact))
      .then(response => processContactResponse(response));
  },
  updateReputation(reputation) {
    return base.http().patch(`${REPUTATION_URL}/${reputation.id}`, formatReputation(reputation))
      .then(response => processReputationResponse(response));
  },
  searchClientByName(name) {
    return base.http().get(`${CLIENT_BY_NAME_URL}${name}&page[limit]=5`)
      .then(response => processClientResponse(response))
      .then((res) => {
        if (res && res.length > 0) {
          const clientsResponse = [];
          res.forEach((clientFromServer) => {
            const clientResponse = clientFromServer;
            if (clientResponse.reputations &&
              clientResponse.reputations.length) {
              clientResponse.reputations.forEach((rep, i) => {
                this.getReputation(rep.id)
                  .then((reputation) => {
                    clientResponse.reputations[i] = reputation;
                  });
              });
            }
            clientsResponse.push(clientResponse);
          });
          return clientsResponse;
        }
        return [];
      });
  },
  searchClientBySurname(surname) {
    return base.http().get(`${CLIENT_BY_SURNAME}${surname}&page[limit]=5`)
      .then(response => processClientResponse(response))
      .then((res) => {
        if (res && res.length > 0) {
          const clientsResponse = [];
          res.forEach((clientFromServer) => {
            const clientResponse = clientFromServer;
            if (clientResponse.reputations &&
              clientResponse.reputations.length) {
              clientResponse.reputations.forEach((rep, i) => {
                this.getReputation(rep.id)
                  .then((reputation) => {
                    clientResponse.reputations[i] = reputation;
                  });
              });
            }
            clientsResponse.push(clientResponse);
          });
          return clientsResponse;
        }
        return [];
      });
  },
  getExistedContactoDNI(dni) {
    return base.http().get(`${EXISTED_CONTACT_DNI_URL}${dni}`)
      .then(response => processContactResponse(response));
  },
  getContactoWithClient(contacto, client) {
    return base.http().get(`${CLIENTE_URL}/${client.id}/relationships/contacto/${contacto.id}`)
      .then(response => processContactResponse(response));
  },
  searchContactoByName(name) {
    return base.http().get(`${CONTACT_BY_NAME_URL}${name}&page[limit]=5`)
      .then(response => processContactResponse(response));
  },
  searchContactoBySurname(surname) {
    return base.http().get(`${CONTACT_BY_SURNAME}${surname}`)
      .then(response => processContactResponse(response));
  },
  searchOperationsByClient(client) {
    return base.http().get(`${OPERATIONS_BY_CLIENT}${client}`)
    .then(response => processOperationsByClient(response, client));
  },
  getReputation(id) {
    return base.http().get(`${REPUTATION_URL}/${id}?include=document`)
      .then(response => processReputationResponse(response))
      .then((reputationFromServer) => {
        if (reputationFromServer.document && reputationFromServer.document.id) {
          return DocumentService.getDocument({ id: reputationFromServer.document.id })
            .then((res) => {
              reputationFromServer.document = res;
              return reputationFromServer;
            });
        }
        return reputationFromServer;
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/tab-cliente/service.js